var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:(_vm.className ? _vm.className + ' ': '') + 'col-md-12 text-center title-logo-png'},[_c('a',{attrs:{"href":_vm.url}},[_c('img',{attrs:{"src":require("../../../public/img/logo.png"),"alt":"logo"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }